import React from "react";
import "./index.css";
import { Spin, Typography } from "antd";

type Props = {
  value: number | string;
  label: string;
  sublabel?: string;
  variant?: "primary" | "secondary";
  size?: "small" | "medium" | "large";
  loading?: boolean;
};

const { Text } = Typography;

const ActivityDisplay: React.FC<Props> = ({
  value,
  label,
  sublabel,
  variant = "primary",
  size = "medium",
  loading = false,
}) => {
  return (
    <Spin spinning={loading} wrapperClassName="activity-spin">
      <div className="relative">
        <div
          className={`activity-display-container activity-display--${variant} activity-display--${size}`}
        >
          <div className="activity-value">{`${value}`}</div>
          <div className="activity-content">
            <div className="activity-label">{label}</div>
            {sublabel && <div className="activity-label">{sublabel}</div>}
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default ActivityDisplay;
